
export enum AddressCodeType {
  ACCPYBLE_A = 'ACCPYBLE A',
  ASEC = 'ASEC',
  BUSINESS_A = 'BUSINESS A',
  BUSINESS_P = 'BUSINESS P',
  BKSRCRDS_A = 'BKSRCRDS A',
  BKSRCRDS_P = 'BKSRCRDS P',
  CONTPERS_A = 'CONTPERS A',
  MAILING_A = 'MAILING  A',
  MAILING_P = 'MAILING  P',
  SOCMEDIA_A = 'SOCMEDIA A',
  PBCEMAIL_A = 'PBCEMAIL A',
  PLANT_A = 'PLANT A',
  XXDEFAULT = 'XXDEFAULT',
}

export const allowedAddressCodeTypes = [ // HY-9001
  AddressCodeType.BUSINESS_A,
  AddressCodeType.MAILING_A,
  AddressCodeType.BKSRCRDS_A,
  AddressCodeType.PLANT_A,
  AddressCodeType.ACCPYBLE_A,
]
